import React from "react";
import NavBar from "../../NavBar"
import Footer from "../../Footer"
import datiBigiotteria from "../../../data/bigiotteriaProdotti.json";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowUp } from '@fortawesome/free-solid-svg-icons'
import { useEffect } from "react";
import ScrollabileRiga from "../ScrollabileRiga";
import Selezione from "../Selezione"

export default function Collane(){

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    function tornaSopra(){
        document.body.scrollTop = 0; 
        document.documentElement.scrollTop = 0;
    }
    useEffect(() => {
            window.addEventListener("scroll",(e)=>{
            const bottone = document.getElementById("btnTop");
            if(window.scrollY===0){
                try {
                    bottone.classList.add("invisibile");
                } catch (error) {
                    return null;
                }
                
                
                setTimeout(() => {
                    try {
                        bottone.classList.add("invisibilePerDavvero")
                    } catch (error) {
                        return null;
                    }
                    
                }, "490");
                try {
                    bottone.classList.remove("visibile");
                } catch (error) {
                    return null;
                }
                
            }else{
                try {
                    bottone.classList.remove("invisibile");
                    bottone.classList.remove("invisibilePerDavvero");
                    bottone.classList.add("visibile");
                } catch (error) {
                    return null;
                }
                
            }
            
        });
        
    });
    
    const arrId = ["In Generale","Donna","Uomo"]    
    return (
        <div className="bigiotteriaBody wuXieKeJi">
            <button id="btnTop" onClick={()=>tornaSopra()}><FontAwesomeIcon icon={faArrowUp} /></button>
            <NavBar uno ="Prodotti" due="Informazioni" tre="Contattaci" one="/prodotti" two="/informazioni" three="/contattaci"/>
            <h1 className="titoloProdotti">Collane</h1>
            <Selezione arr={arrId}/>

            <div className="premessaProdotti">
                <p>A causa di un ecessivo numero di collane, qui mostriamo in dettaglio solo alcuni modelli.</p>
            </div>
            
            <div className="colonna bigiotteria">

                <ScrollabileRiga idTitolo="InGenerale" titolo="In Generale" idScroll1="1" idScroll2="2" dati={datiBigiotteria} tipo="collane" sottoTipo1="overView7" sottoTipo2="overView8" nomeDati="bigiotteriaProdotti"/>
                
                <hr className="separatore"/>

                <ScrollabileRiga idTitolo="Donna" titolo="Donna" idScroll1="3" idScroll2="4" dati={datiBigiotteria} tipo="collane" sottoTipo1="d1" sottoTipo2="d2" nomeDati="bigiotteriaProdotti"/>

                <hr className="separatore"/>

                <ScrollabileRiga idTitolo="Uomo" titolo="Uomo" idScroll1="5" idScroll2="6" dati={datiBigiotteria} tipo="collane" sottoTipo1="u1" sottoTipo2="u2" nomeDati="bigiotteriaProdotti"/>

                

            </div>
            <Footer />
        </div>
    )
}